import { cn } from '@/utils';
import { Check, X } from 'lucide-react';

export const PasswordRequirement = ({ children, isMet, shouldHighlight = false }: { children: React.ReactNode; isMet: boolean; shouldHighlight?: boolean }) => (
  <li className='text-body-s-regular flex items-center gap-2'>
    {!isMet && (
      <X
        size={16}
        className={cn({
          'text-text-error-primary': shouldHighlight && !isMet,
        })}
      />
    )}
    {isMet && <Check size={16} className='text-fill-status-green' />}
    <span
      className={cn(
        {
          'text-text-error-primary': shouldHighlight && !isMet,
        },
        { 'text-fill-status-green': isMet },
      )}
    >
      {children}
    </span>
  </li>
);
